import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { BrandService } from '../core/services/brand.service';
import { TokenStorageService } from '../core/services/token-storage.service';
import { IClientPortalDetailsResponse } from '../models/billing.model';
import { BillPayService } from '../services/bill-pay.service';
import { PortalFooterComponent } from './portal-footer.component';
import { PortalSidebarComponent } from './portal-sidebar.component';

@Component({
  selector: 'app-portal-layout',
  standalone: true,
  imports: [RouterOutlet, PortalFooterComponent, PortalSidebarComponent],
  template: `
    <div class="portal-shell d-flex flex-column min-vh-100">
      <header class="portal-banner">
        <div class="container d-flex align-items-center justify-content-between py-3">
          <a [href]="brandService.brand.website" target="_blank" rel="noopener" class="banner-brand">
            <img [src]="brandService.brand.logoWhite" [alt]="brandService.brand.name" class="banner-logo" />
          </a>
          <div class="banner-title d-none d-md-block">Client Portal</div>
          <button type="button" class="btn btn-outline-light btn-sm" (click)="logout()">
            Logout
          </button>
        </div>
      </header>
      <div class="portal-body d-flex flex-grow-1">
        <app-portal-sidebar [details]="details"></app-portal-sidebar>
        <main class="flex-grow-1 portal-content">
          <router-outlet></router-outlet>
        </main>
      </div>
      <app-portal-footer></app-portal-footer>
    </div>
  `,
  styles: [
    `
      .portal-shell {
        background-color: var(--portal-bg);
      }
      .portal-banner {
        background-color: var(--portal-header-bg);
        color: #fff;
        box-shadow: 0 2px 6px rgba(var(--portal-shadow-rgb), 0.25);
      }
      .portal-banner .banner-brand {
        display: inline-flex;
        align-items: center;
      }
      .portal-banner .banner-logo {
        height: 38px;
        width: auto;
      }
      .portal-banner .banner-title {
        font-size: 1.1rem;
        font-weight: 500;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.85);
      }
      .portal-banner .btn-outline-light:hover {
        background-color: var(--portal-chrome-hover-bg);
        border-color: var(--portal-chrome-hover-bg);
        color: var(--portal-chrome-hover-fg);
      }
      .portal-body {
        align-items: stretch;
      }
      .portal-content {
        min-width: 0;
      }
    `,
  ],
})
export class PortalLayoutComponent implements OnInit {
  protected brandService = inject(BrandService);
  private billPayService = inject(BillPayService);
  private tokenStorage = inject(TokenStorageService);
  private router = inject(Router);

  details: IClientPortalDetailsResponse | null = null;

  ngOnInit(): void {
    this.billPayService.getDetails().subscribe({
      next: (details) => {
        this.details = details;
        this.brandService.setCustomerType(details.customerType);
      },
    });
  }

  logout(): void {
    this.tokenStorage.clearToken();
    this.brandService.clearStoredBrand();
    this.router.navigate(['/login']);
  }
}
